import { cascadesign } from '../request';
export default {
  props: {
    // index: {
    //   type: Number
    // },
    // controlMark: {
    //   type: String
    // }
    isEdit: {
      type: Boolean,
      default: true
    },
    itemData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      canvasContext: null,
      signatureIMAGE: '',
      isDrawing: false,
      lastX: 0,
      lastY: 0,
      canvasWidth: 870,
      canvasHeight: 200,
      isSignatureEmpty: false,
      //清除
      isUploading: true,
      //上传

      showSignature: false,
      // 控制签名的显示和隐藏状态
      imgurl: ''
    };
  },
  computed: {
    indexID() {
      return this.index;
    }
  },
  mounted() {
    // console.log(this.itemData, this.isEdit, '----itemData-----');
    if (this.itemData) {
      this.imgurl = 'https://test-insurforce.oss-cn-beijing.aliyuncs.com/insurforce/fileTemplate/temp/20230915/22:37:09/df0a6226f7bdcb8ae28054872ca47a27.jpg';
    }
    this.canvasContext = this.$refs.canvas.getContext('2d');
    this.resizeCanvas();
    window.addEventListener('resize', this.resizeCanvas);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeCanvas);
  },
  methods: {
    async getcascadesign(item) {
      const currentOptions = await cascadesign({
        sign: item
      });
      this.imgurl = currentOptions.fileTempUrl;
      this.$emit('update:controlMark', currentOptions.fileTempUrl);
      this.isUploading = true; // 点击上传把上传按钮置灰

      this.showSignature = false; // 成功上传后隐藏签名
      // this.itemMark = currentOptions;
    },
    startDrawing(event) {
      this.isDrawing = true;
      this.lastX = event.clientX - this.$refs.canvas.getBoundingClientRect().left;
      this.lastY = event.clientY - this.$refs.canvas.getBoundingClientRect().top;
      this.isUploading = false;
    },
    draw(event) {
      if (!this.isDrawing) return;
      const x = event.clientX - this.$refs.canvas.getBoundingClientRect().left;
      const y = event.clientY - this.$refs.canvas.getBoundingClientRect().top;
      this.canvasContext.beginPath();
      this.canvasContext.lineWidth = 2; // 设置线条宽度为2像素（根据需求调整宽度）
      this.canvasContext.moveTo(this.lastX, this.lastY);
      this.canvasContext.lineTo(x, y);
      this.canvasContext.stroke();
      this.lastX = x;
      this.lastY = y;
    },
    stopDrawing() {
      this.isDrawing = false;
    },
    // 清空
    clearCanvas() {
      this.showSignature = true; // 清空画布后显示签名
      // this.isUploading = true;
      this.canvasContext.clearRect(0, 0, this.canvasWidth, this.canvasHeight);
      this.controlMark = '';
      this.$emit('update:controlMark', this.controlMark);
      this.resizeCanvas();
      // this.formDataArray[this.indexID].url = '';
      // this.$emit('my-event', this.formDataArray[this.indexID].url == '');
      this.isUploading = true; // 点击清空把上传按钮置灰
    },
    // 上传
    saveSignature() {
      const signatureData = this.$refs.canvas.toDataURL();
      // console.log('555555------55', signatureData);

      this.getcascadesign(signatureData);
      this.isUploading = true; //点击上传把上传按钮置灰

      // this.$emit('my-event', this.formDataArray[this.indexID].url);
    },
    resizeCanvas() {
      const container = this.$refs.canvas.parentElement;
      this.canvasWidth = container.offsetWidth;
      this.canvasHeight = container.offsetHeight;
      this.$refs.canvas.width = this.canvasWidth;
      this.$refs.canvas.height = this.canvasHeight;
    }
  }
};